function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const Bundle = (Component, routeProps = {}) => props => /*#__PURE__*/React.createElement(Component, _extends({}, props, routeProps));
export function bundleRoutingMiddleware(action, nextRoute, prevRoute) {
  const {
    match
  } = nextRoute;
  if (match && !match.render && typeof match.load === 'function') {
    match.load(asyncModule => {
      match.render = Bundle(asyncModule.default ? asyncModule.default : asyncModule, match.props);
      action.ok();
    });
  } else {
    action.ok();
  }
}
//# sourceMappingURL=bundle.js.map